<template>
  <div>
    <br />
    <h2 class="ViewHeading">Devices and Routers</h2>
    <div>
      <b-row
        ><b-col>
          <h4>{{ this.selectedlocation }}</h4>
        </b-col></b-row
      >

      <b-row> </b-row>
    </div>
    <b-card>
      <EndPoints></EndPoints>
    </b-card>
  </div>
</template>

<script>
import {} from "bootstrap-vue";
import EndPoints from "../components/Endpoints.vue";

export default {
  computed: {},
  components: {
    EndPoints,

  },

  data() {
    return {

      selectedlocation: localStorage.getItem("CurrentLocation"),
     
    };
  },

  beforeMount() {},

  mounted() {
   
  },

  methods: {
    getUserInitials() {
      this.userInitials = localStorage.getItem("UserInitials");
      return this.userInitials;
    },
    userfullname() {
      this.userfullname = localStorage.getItem("fullname");
      return this.userfullname;
    },

  },
};
</script>

<style>
</style>
